(function () {
  "use strict";

  var w = window;
  var d = document;
  if (w.__pvLinkedInTrackingLoaded) return;
  w.__pvLinkedInTrackingLoaded = true;

  var config = w.PromoVistaLinkedInTracking || {};
  var conversionIds = config.conversionIds || {};
  var eventPrefix = "promo_vista:linkedin_";
  var directEventPrefix = "pv_linkedin_";
  var fired = w.__pvLinkedInTrackingFired = w.__pvLinkedInTrackingFired || {};
  var cooldowns = w.__pvLinkedInTrackingCooldowns = w.__pvLinkedInTrackingCooldowns || {};

  function hasMarketingConsent() {
    if (!w.Cookiebot) return true;
    if (!w.Cookiebot.consent) return false;
    return w.Cookiebot.consent.marketing === true;
  }

  function setupLinkedInInsightTag() {
    var partnerId = String(config.partnerId || "").trim();
    if (!partnerId || !hasMarketingConsent()) return;

    w._linkedin_partner_id = partnerId;
    w._linkedin_data_partner_ids = w._linkedin_data_partner_ids || [];
    if (w._linkedin_data_partner_ids.indexOf(partnerId) === -1) {
      w._linkedin_data_partner_ids.push(partnerId);
    }

    if (d.querySelector('script[src*="snap.licdn.com/li.lms-analytics/insight.min.js"]')) return;

    if (!w.lintrk) {
      w.lintrk = function (a, b) {
        w.lintrk.q.push([a, b]);
      };
      w.lintrk.q = [];
    }

    var firstScript = d.getElementsByTagName("script")[0];
    var tag = d.createElement("script");
    tag.type = "text/javascript";
    tag.async = true;
    tag.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    firstScript.parentNode.insertBefore(tag, firstScript);
  }

  function searchParams() {
    try {
      return new URLSearchParams(w.location.search || "");
    } catch (error) {
      return new URLSearchParams("");
    }
  }

  function currentLander() {
    var path = w.location.pathname.toLowerCase();
    if (path.indexOf("/pages/custom-pos-merkactivatie") !== -1 || path.indexOf("/pages/merkactivatie-offerte") !== -1) {
      return "custom_pos_merkactivatie";
    }
    if (path.indexOf("/pages/bar-activation-toolkit") !== -1) {
      return "bar_activation_toolkit";
    }
    return "";
  }

  function attributionPayload() {
    var params = searchParams();
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
      li_fat_id: params.get("li_fat_id") || "",
      gclid: params.get("gclid") || "",
      fbclid: params.get("fbclid") || ""
    };
  }

  function basePayload(extra) {
    var lander = currentLander();
    var payload = {
      event_id: "pv-li-" + Date.now() + "-" + Math.random().toString(16).slice(2),
      page_url: w.location.href,
      page_path: w.location.pathname,
      page_title: d.title || "",
      lander: lander,
      source: "promo_vista_shopify_theme",
      timestamp: new Date().toISOString()
    };
    Object.assign(payload, attributionPayload(), extra || {});
    return payload;
  }

  function publish(eventName, extra, options) {
    var opts = options || {};
    var key = opts.onceKey || "";
    if (key && fired[key]) return;
    if (key) fired[key] = true;

    var payload = basePayload(extra);
    var dataLayerEvent = directEventPrefix + eventName;

    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(Object.assign({ event: dataLayerEvent }, payload));

    if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === "function") {
      w.Shopify.analytics.publish(eventPrefix + eventName, payload);
    }

    try {
      w.dispatchEvent(new CustomEvent("promo-vista:linkedin-event", {
        detail: { eventName: eventName, payload: payload }
      }));
    } catch (error) {}

    fireLinkedInConversion(eventName);
  }

  function publishWithCooldown(eventName, extra, key, waitMs) {
    var cooldownKey = eventName + ":" + (key || "default");
    var now = Date.now();
    if (cooldowns[cooldownKey] && now - cooldowns[cooldownKey] < (waitMs || 1500)) return;
    cooldowns[cooldownKey] = now;
    publish(eventName, extra);
  }

  function fireLinkedInConversion(eventName) {
    var conversionId = String(conversionIds[eventName] || "").trim();
    if (!conversionId || !hasMarketingConsent() || typeof w.lintrk !== "function") return;
    w.lintrk("track", { conversion_id: conversionId });
  }

  function linkHref(element) {
    var link = element && element.closest ? element.closest("a[href]") : null;
    return link ? String(link.getAttribute("href") || "") : "";
  }

  function linkText(element) {
    var link = element && element.closest ? element.closest("a[href], button") : null;
    return link ? String(link.textContent || "").replace(/\s+/g, " ").trim().slice(0, 160) : "";
  }

  function closestForm(element) {
    return element && element.closest ? element.closest("form") : null;
  }

  function buttonText(element) {
    var control = element && element.closest ? element.closest("button, input[type='submit'], [role='button']") : null;
    if (!control) return "";
    return String(control.value || control.textContent || "").replace(/\s+/g, " ").trim().slice(0, 160);
  }

  function isCartAddUrl(url) {
    return String(url || "").toLowerCase().indexOf("/cart/add") !== -1;
  }

  function isCheckoutUrl(url) {
    var value = String(url || "").toLowerCase();
    return value.indexOf("/checkout") !== -1 || value.indexOf("checkout.shopify.com") !== -1;
  }

  function isCheckoutControl(element) {
    var control = element && element.closest ? element.closest("button, input[type='submit'], [role='button']") : null;
    if (!control) return false;
    var name = String(control.getAttribute("name") || "").toLowerCase();
    var value = String(control.value || control.textContent || "").toLowerCase();
    return name === "checkout" || value.indexOf("checkout") !== -1 || value.indexOf("afrekenen") !== -1;
  }

  function formPayload(form, extra) {
    var id = String(form && form.id || "");
    var action = String(form && form.getAttribute && form.getAttribute("action") || "");
    var variantInput = form && form.querySelector ? form.querySelector("[name='id']") : null;
    var quantityInput = form && form.querySelector ? form.querySelector("[name='quantity']") : null;
    var payload = {
      form_id: id,
      form_action: action,
      variant_id: variantInput ? String(variantInput.value || "") : "",
      quantity: quantityInput ? String(quantityInput.value || "") : "",
      lander: currentLander()
    };
    Object.assign(payload, extra || {});
    return payload;
  }

  function handleClick(event) {
    var target = event.target;
    var href = linkHref(target);
    var hrefLower = href.toLowerCase();
    var text = linkText(target);
    var lander = currentLander();
    var form = closestForm(target);

    if (isCheckoutUrl(href) || isCheckoutControl(target)) {
      publishWithCooldown("checkout_started", {
        click_text: text || buttonText(target),
        click_url: href,
        lander: lander,
        source_event: "theme_checkout_intent"
      }, "checkout", 2000);
      return;
    }

    if (isCartAddUrl(href) || (form && isCartAddUrl(form.getAttribute("action")))) {
      publishWithCooldown("add_to_cart", formPayload(form || d.createElement("form"), {
        click_text: text || buttonText(target),
        click_url: href,
        source_event: "theme_add_to_cart_click"
      }), "add-to-cart", 1500);
      return;
    }

    if (hrefLower.indexOf("wa.me/") !== -1 || hrefLower.indexOf("api.whatsapp.com") !== -1) {
      publish("whatsapp_click", { click_text: text, click_url: href, lander: lander });
      return;
    }

    if (hrefLower.indexOf("#powerful-form-140412") !== -1 || hrefLower.indexOf("#globo-formbuilder-140412") !== -1) {
      publish("custom_pos_form_open", { click_text: text, click_url: href, lander: lander });
      return;
    }

    if (
      hrefLower.indexOf("promo-vista-bar-activation-toolkit-whitepaper.pdf") !== -1 ||
      (target.closest && target.closest("a[download]") && lander === "bar_activation_toolkit")
    ) {
      publish("lead_magnet_download", { click_text: text, click_url: href, lander: lander }, { onceKey: "lead_magnet_download" });
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches("form")) return;
    var id = String(form.id || "");
    var action = String(form.getAttribute("action") || "").toLowerCase();
    var lander = currentLander();

    if (id.indexOf("ContactFormBarActivationToolkit") === 0) {
      publish("lead_magnet_form_submit", { form_id: id, lander: "bar_activation_toolkit" }, { onceKey: "lead_magnet_form_submit:bar_activation_toolkit" });
      return;
    }

    if (id.indexOf("CustomerFormBarActivationToolkit") === 0) return;

    if (form.closest("#globo-formbuilder-140412, #powerful-form-140412, .globo-formbuilder, .gfb__form, [class*='globo-formbuilder']")) {
      publish("custom_pos_form_submit", { form_id: id, lander: lander }, { onceKey: "custom_pos_form_submit:" + (id || lander || "unknown") });
      return;
    }

    if (isCartAddUrl(action)) {
      publishWithCooldown("add_to_cart", formPayload(form, {
        lander: lander,
        source_event: "theme_add_to_cart_submit"
      }), "add-to-cart", 1500);
      return;
    }

    if (action.indexOf("/cart") !== -1 && form.querySelector("[name='checkout']")) {
      publishWithCooldown("checkout_started", formPayload(form, {
        lander: lander,
        source_event: "theme_checkout_submit"
      }), "checkout", 2000);
    }
  }

  function setupAjaxCartTracking() {
    if (w.__pvLinkedInAjaxCartTrackingLoaded) return;
    w.__pvLinkedInAjaxCartTrackingLoaded = true;

    if (typeof w.fetch === "function") {
      var nativeFetch = w.fetch;
      w.fetch = function () {
        var requestUrl = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
        var isCartAdd = isCartAddUrl(requestUrl);
        return nativeFetch.apply(this, arguments).then(function (response) {
          if (isCartAdd && response && response.ok) {
            publishWithCooldown("add_to_cart", {
              request_url: String(requestUrl || ""),
              source_event: "ajax_cart_add_fetch"
            }, "add-to-cart", 1500);
          }
          return response;
        });
      };
    }

    if (w.XMLHttpRequest && w.XMLHttpRequest.prototype) {
      var nativeOpen = w.XMLHttpRequest.prototype.open;
      var nativeSend = w.XMLHttpRequest.prototype.send;
      w.XMLHttpRequest.prototype.open = function (method, url) {
        this.__pvLinkedInCartAddUrl = isCartAddUrl(url) ? String(url || "") : "";
        return nativeOpen.apply(this, arguments);
      };
      w.XMLHttpRequest.prototype.send = function () {
        if (this.__pvLinkedInCartAddUrl) {
          this.addEventListener("load", function () {
            if (this.status >= 200 && this.status < 400) {
              publishWithCooldown("add_to_cart", {
                request_url: this.__pvLinkedInCartAddUrl,
                source_event: "ajax_cart_add_xhr"
              }, "add-to-cart", 1500);
            }
          });
        }
        return nativeSend.apply(this, arguments);
      };
    }
  }

  function observePowerfulFormSuccess() {
    var successPattern = /(thank you|thanks|bedankt|dank je|succesvol|successfully)/i;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var node = mutations[i].target;
        if (!node || !node.textContent) continue;
        if (!node.closest || !node.closest("#globo-formbuilder-140412, #powerful-form-140412, .globo-formbuilder, [class*='globo-formbuilder']")) continue;
        if (successPattern.test(node.textContent)) {
          publish("custom_pos_form_success", { lander: currentLander() }, { onceKey: "custom_pos_form_success" });
          return;
        }
      }
    });
    observer.observe(d.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function trackInitialState() {
    var lander = currentLander();
    var params = searchParams();
    if (lander) {
      publish("lander_view", { lander: lander }, { onceKey: "lander_view:" + lander });
    }
    if (lander === "bar_activation_toolkit" && params.get("contact_posted") === "true") {
      publish("lead_magnet_form_complete", { lander: lander }, { onceKey: "lead_magnet_form_complete" });
    }
  }

  function init() {
    setupLinkedInInsightTag();
    trackInitialState();
    setupAjaxCartTracking();
    d.addEventListener("click", handleClick, true);
    d.addEventListener("submit", handleSubmit, true);
    observePowerfulFormSuccess();
  }

  if (d.readyState === "loading") {
    d.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  w.addEventListener("CookiebotOnAccept", setupLinkedInInsightTag);
})();
